import { render, staticRenderFns } from "./CurationListReceiveLayout.vue?vue&type=template&id=3bfee45a&scoped=true"
import script from "./CurationListReceiveLayout.vue?vue&type=script&lang=js"
export * from "./CurationListReceiveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfee45a",
  null
  
)

export default component.exports